import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import WireDetailsModal from '../../TransactionsPage/WireDetailsModal';
import {StyledAddFundsDetailsButton} from './StyledAddFundsDetails';
import AuthenticationWindow from '../../CardsPage/AuthenticationWindow';
import {bankingActions} from '../../../../state/actions/banking.actions';
import {transactionActions} from '../../../../state/actions/transaction.actions';
import {SCAActionsConstants} from '../../../../constants';
import {scaHelpers, systemHelpers} from '../../../../utils/helpers';
import {firebaseEvents} from '../../../../snippets/firebase';

const SCA_OPERATION_NAME = SCAActionsConstants.ADD_FUNDS_LOADING;

const AddFundsDetails = ({
  companyBankingUserId,
  displayWalletDetailsInitially,
  details = {bic: null, iban: null },
  getUserWallets,
  storeWireDetails
}) => {
  const [t] = useTranslation('main');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [authWindowProps, setAuthWindowProps] = useState({open: false});

  useEffect(() => {
    if (displayWalletDetailsInitially) {
      loadWalletDetails();
    }
  }, [displayWalletDetailsInitially]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadWalletDetails = () => {
    getUserWallets({
      headers: scaHelpers.getAuthHeaders(SCA_OPERATION_NAME),
      id: companyBankingUserId,
      successCallback: (wallets) => {
        if (wallets.length > 0) {
          const wallet = wallets[0];
          storeWireDetails(wallet, true);
        } else {
          storeWireDetails(undefined);
        }
        setOpenDetailsModal(true);
      },
      errorCallback: (response) => {
        scaHelpers.SCAResponseCallback({
          response,
          scaCallback: (scaProps) => setAuthWindowProps({...authWindowProps, ...scaProps})
        });
      }
    });
    systemHelpers.logEvent(firebaseEvents.ADD_FUND_BUTTON_CLICK);
  }

  const handleCloseModal = () => setOpenDetailsModal(false);

  const handleCloseAuthModal = () => setAuthWindowProps({...authWindowProps, open: false});

  const handleOnSuccessAuth = () => {
    handleCloseAuthModal();
    loadWalletDetails();
  }

  return (
    <>
      <StyledAddFundsDetailsButton
        className='primary-outline'
        onClick={loadWalletDetails}
      >
        {t('add')} {t('funds')}
      </StyledAddFundsDetailsButton>

      <WireDetailsModal
        details={details}
        onCancel={handleCloseModal}
        onOk={handleCloseModal}
        open={openDetailsModal}
      />

      <AuthenticationWindow
        {...authWindowProps}
        handleCancel={handleCloseAuthModal}
        onSuccess={handleOnSuccessAuth}
        operationName={SCA_OPERATION_NAME}
      />
    </>
  );
}


AddFundsDetails.propTypes = {
  details: PropTypes.shape({
    bic: PropTypes.string,
    iban: PropTypes.string
  })
}

const mapStateToProps = ({ transaction, main }) => ({
  companyBankingUserId: transaction.companyBankingUserId,
  displayWalletDetailsInitially: main.displayWalletDetailsInitially,
});

const mapDispatchToProps = {
  getUserWallets: bankingActions.getUserWallets,
  storeWireDetails: transactionActions.storeWireDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddFundsDetails);
